import { Observable, Subject } from "rxjs";

export class SimpleValidation {

    patternIndex?: string;
    validationType?: 'equal' | 'not-equal' | 'less-than' | 'greater-than' | 'contains';
    value?: any;
    valueProperty?: string;
    controlAlias?: string;
    onlyValue?: boolean;
    response?: boolean;
    validationSubject = new Subject<boolean>();
    isStatic?: boolean;
    staticValue?: any;
    staticProperty?: string;

    constructor(source: Partial<SimpleValidation>) {
        this.onlyValue = false;
        this.isStatic = false;
        Object.assign(this, source);
    }

    getObservable(): Observable<boolean> {
        return this.validationSubject.asObservable();
    }

    validate(value: any) {
        let response: boolean = false;

        if (this.isStatic) {
            value = this.staticValue;
        }

        if (this.onlyValue) {
            response = this.value;
        } else {
            switch (this.validationType) {
                case "equal":
                    response = this.value == value;
                    break;
                case "not-equal":
                    response = this.value != value;
                    break;
                case "greater-than":
                    response = this.value > value;
                    break;
                case "less-than":
                    response = this.value < value;
                    break;
                case "contains":
                    response = this.value.includes(value);
                    break;
            }
        }

        this.response = response;
        this.validationSubject.next(response);
    }
}